import { cn } from '@/platform/lib/utils';
import FilterBarDropdown from './FilterBarDropdown';
import FilterBarInput from './FilterBarInput';
import FilterBarPlaceholder from './FilterBarPlaceholder';
import FilterBarSearch from './FilterBarSearch';
import FilterBarToggle from './FilterBarToggle';

const FilterBar = ({ className, children, ...props }) => (
    <div
        className={cn(
            'mb-4 flex items-stretch divide-x divide-gray-200 overflow-hidden rounded-md border border-gray-200 bg-white',
            className
        )}
        {...props}
    >
        {children}
    </div>
);

FilterBar.Search = FilterBarSearch;
FilterBar.Toggle = FilterBarToggle;
FilterBar.Dropdown = FilterBarDropdown;
FilterBar.Input = FilterBarInput;
FilterBar.FilterBarPlaceholder = FilterBarPlaceholder;

export default FilterBar;
